import { computed } from 'vue';
import { useDialog } from '@negar/core';
import { NewsItem as NewsItemType } from '@libs/api-reference';
import { sleep } from '@libs/utils';

import { NewsDialog, NewsFilterDialog } from '@/modules/news';

import { i18n } from '@/plugins/i18n';

const { t } = i18n.global;

export default function useNewsDialogs() {
  const { add: addDialog } = useDialog();

  const openNewsFilter = () => {
    addDialog({
      title: `${t('common.filter')} ${t('modules.news.supervisor_message')}`,
      content: computed(() => ({
        component: NewsFilterDialog,
        props: {},
      })),
    });
  };

  const openNewsItemDialog = async (item: NewsItemType) => {
    if (item) {
      await sleep();

      addDialog({
        wrapperClass: '!w-1/4',
        bodyClass: '!w-full',
        title: t('modules.news.supervisor_message'),
        multiple: true,
        content: computed(() => ({
          component: NewsDialog,
          props: {
            selectedNews: item,
          },
        })),
      });
    }
  };

  return { openNewsFilter, openNewsItemDialog };
}
